export default __webpack_public_path__ + "static/media/CarImages.SorentoGallery2.6fd572b5.jpg";